const isDataset = (value) => typeof value === "object" && value !== null && "columns" in value && "data" in value && Array.isArray(value.columns) && Array.isArray(value.data);
export {
  isDataset
};
